// Language and theme are ONE setting across jawabai.cloud, app.jawabai.cloud and
// auth.jawabai.cloud. They are different origins, so localStorage cannot be
// shared; a cookie on the parent domain can. The cookie is the source of truth
// and localStorage is only the fallback when cookies are blocked. Keycloak's
// login theme (keycloak/.../js/*.js) reads and writes the same cookies, and the
// frontend-app sends the language to the gateway as X-Lang for emails.
//
// Keep this file identical in frontend-app and frontend-landing.
const ALLOWED = {
  jawabai_lang: ['ar', 'en'],
  jawabai_theme: ['light', 'dark'],
};
const ONE_YEAR = 365 * 24 * 60 * 60;

function cookieAttrs() {
  const host = window.location.hostname;
  const domain =
    host === 'jawabai.cloud' || host.endsWith('.jawabai.cloud')
      ? '; domain=.jawabai.cloud'
      : '';
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  return `; path=/; max-age=${ONE_YEAR}; samesite=lax${domain}${secure}`;
}

function fromCookie(name) {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : null;
  } catch {
    return null;
  }
}

function fromStorage(name) {
  try {
    return localStorage.getItem(name);
  } catch {
    return null;
  }
}

// The saved value for `name`, or null if nothing valid is stored.
export function readPref(name) {
  const ok = ALLOWED[name];
  const v = fromCookie(name);
  if (ok.includes(v)) return v;
  const s = fromStorage(name);
  return ok.includes(s) ? s : null;
}

export function writePref(name, value) {
  if (!ALLOWED[name].includes(value)) return;
  try {
    document.cookie = `${name}=${value}${cookieAttrs()}`;
  } catch {
    // cookies blocked: the other sites just fall back to their own default
  }
  try {
    localStorage.setItem(name, value);
  } catch {
    // private mode / blocked storage: the choice just won't survive a reload
  }
}
